import App from './App'
// import Vuex from "vuex";


import uviewPlus from '@/uni_modules/uview-plus'


// import uView from '@/uni_modules/uview-ui/'
// Vue.use(uView)

// 如此配置即可
// uni.$u.config.unit = 'rpx' 

// 调用setConfig方法，方法内部会进行对象属性深度合并，可以放心嵌套配置
// 需要在Vue.use(uView)之后执行
// uni.$u.setConfig({
// 	// 修改$u.config对象的属性
// 	config: {
// 		// 修改默认单位为rpx，相当于执行 uni.$u.config.unit = 'rpx'
// 		unit: 'rpx'
// 	},
// 	// 修改$u.props对象的属性
// 	props: {
// 		// 修改radio组件的size参数的默认值，相当于执行 uni.$u.props.radio.size = 30
// 		radio: {
// 			size: 15
// 		}
// 		// 其他组件属性配置
// 		// ......
// 	}
// })



//接口配置
import store from '@/store';
import _request from "@/plugin/request.js"
import _log from "@/plugin/log.js"
import _message from "@/plugin/message.js"


// #ifndef VUE3
import Vue from 'vue'
import './uni.promisify.adaptor'
Vue.config.productionTip = false

// Vue.prototype.$store = store
// Vue.prototype.$api = _request.api;
// Vue.prototype.$apiUpload = _request.apiUpload;
// Vue.prototype.$log = _log.log;
// Vue.prototype.$alert = _message.alert; 



App.mpType = 'app'
const app = new Vue({
	...App
})
app.$mount()
// #endif

// #ifdef VUE3

// import * as mixin from '@/mixin'
// import globalMixin from '@/mixin/mixin.js'  // 直接导入 mixin 对象
// console.log(' ================= main.js mixin ================= ', globalMixin)
// console.log(' ================= main.js globalMixin ================= ',globalMixin)
// console.log('main.js mixin', mixin)

import mixin from '@/mixin/index.js'
// Vue.mixin(mixin);



import {
	createSSRApp
} from 'vue'
export function createApp() {
	const app = createSSRApp(App)

	// app.config.globalProperties.$http = () => {};
	app.config.globalProperties.$store = store;
	app.config.globalProperties.$api = _request.api;
	app.config.globalProperties.$apiUpload = _request.apiUpload;
	app.config.globalProperties.$log = _log.log;
	app.config.globalProperties.$alert = _message.alert;


	app.use(store);
	// app.mixin(globalMixin) // 注册全局混入
	app.mixin(mixin) // 注册全局混入
	
	
	app.use(uviewPlus)

	// app.use(mixin)
	// app.mixin(mixin)
	// app.use(uView)


	// 全局属性挂载
	// app.config.globalProperties.$u = uView

	// // 兼容Vue2写法
	// app.provide('$u', uView)

	// // 新版注册方式
	// uView.install(app)

	// // 配置默认单位
	// uni.$u.config.unit = 'rpx'

	return {
		app,
		// Vuex, // 如果 nvue 使用 vuex 的各种map工具方法时，必须 return Vuex
	}
}
// #endif